import { useExecutePiano } from "~/components/Piano/useExecutePiano";
import { ExecutePianoProps } from "./useExecutePiano-types";

export const ExecutePiano: React.FC<
  ExecutePianoProps & { pageProps?: { postId?: number } }
> = ({ pageProps, ...props }) => {
  useExecutePiano(props, pageProps);
  return null;
};
